/**
 * Minimal RFC-4180 CSV reader, used only to show an uploaded .csv beside the form the way
 * DocumentPreview shows a PDF. Parsing that decides money happens on the server; this is
 * for looking at.
 */

/** Rows past this are not rendered — a preview pane does not need to scroll 10k rows. */
export const CSV_PREVIEW_ROW_LIMIT = 500;

/**
 * @param {string} text  raw file contents
 * @param {number} maxRows  stop after this many rows (0 = no limit)
 * @returns {string[][]}
 */
export function parseCsv(text, maxRows = 0) {
    let input = String(text ?? '');

    // CAT Scale (and Excel generally) writes a UTF-8 BOM; left in place it would become
    // part of the first header cell.
    if (input.charCodeAt(0) === 0xFEFF) {
        input = input.slice(1);
    }

    const rows = [];
    let row = [];
    let field = '';
    let inQuotes = false;

    for (let i = 0; i < input.length; i++) {
        const char = input[i];

        if (inQuotes) {
            if (char === '"') {
                // "" inside a quoted field is a literal quote.
                if (input[i + 1] === '"') {
                    field += '"';
                    i++;
                } else {
                    inQuotes = false;
                }
            } else {
                field += char;
            }
            continue;
        }

        if (char === '"') {
            inQuotes = true;
        } else if (char === ',') {
            row.push(field);
            field = '';
        } else if (char === '\n') {
            row.push(field);
            field = '';
            rows.push(row);
            row = [];

            if (maxRows > 0 && rows.length >= maxRows) {
                return rows;
            }
        } else if (char !== '\r') {
            field += char;
        }
    }

    // A trailing newline leaves nothing behind; anything else is a final unterminated row.
    if (field !== '' || row.length > 0) {
        row.push(field);
        rows.push(row);
    }

    return rows;
}

/** Read a File into text. Wrapped so the dialog can await it like any other async step. */
export function readFileAsText(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result ?? ''));
        reader.onerror = () => reject(reader.error);
        reader.readAsText(file);
    });
}
